import { Component } from '@angular/core';

/** Minimal wrapper so `/preview/...` can use child routes under a single primary outlet. */
@Component({
    selector: 'app-preview-shell',
    template: '<router-outlet></router-outlet>',
})
export class PreviewShellComponent {}
